import api from "./axios";
import type { OperationsTeam } from "../types/operationsTeam";
import { mapOperationsTeamResponse, mapOperationsTeamsResponse } from "../types/operationsTeam";

export const getOperationsTeamsApi = async (): Promise<OperationsTeam[]> => {
  try {
    const response = await api.get<any>("/api/v1/operationsTeams");
    return mapOperationsTeamsResponse(response.data);
  } catch (error) {
    console.error("Error fetching operations teams:", error);
    throw error;
  }
};

interface CreateOperationsTeamData {
  name: string;
  userIds: string[];
}

export const createOperationsTeamApi = async (data: CreateOperationsTeamData) => {
  try {
    const response = await api.post("/api/v1/operationsTeams", data);
    return mapOperationsTeamResponse(response.data.data.operationsTeam);
  } catch (error) {
    console.error("Error creating operations team:", error);
    throw error;
  }
};

interface UpdateOperationsTeamData {
  name: string;
  userIds: string[];
}

export const updateOperationsTeamApi = async (teamId: string, data: UpdateOperationsTeamData) => {
  try {
    const response = await api.put(`/api/v1/operationsTeams/${teamId}`, data);
    return mapOperationsTeamResponse(response.data.data.operationsTeam);
  } catch (error) {
    console.error("Error updating operations team:", error);
    throw error;
  }
};
